import { z } from 'zod/v4'

import { jsonDocument } from '../../contract/index.js'
import { defineScreen, type ScreenData } from '../define-screen.js'
import { freshnessSchema } from '../freshness.js'

import { auditEventRowSchema } from './audit-common.js'

/** One event with what the list does not carry: the values before and after the change and the user agent. */
export const auditEventDetailSchema = z.strictObject({
  ...auditEventRowSchema.shape,
  before: jsonDocument({
    reason:
      'audit_log.old_values: the values before the change, written by each audited route with its own keys',
  }).nullable(),
  after: jsonDocument({
    reason:
      'audit_log.new_values: the values after the change, written by each audited route with its own keys',
  }).nullable(),
  userAgent: z.string().nullable(),
})

export const adminAuditEventScreen = defineScreen({
  id: 'admin.audit.event',
  path: '/api/screens/admin/audit/event',
  access: 'super_admin',
  query: z.strictObject({ id: z.guid() }),
  response: z.strictObject({ event: auditEventDetailSchema, freshness: freshnessSchema }),
  dependsOn: [],
  budget: { requests: 1, statements: 1, bytes: 20_000, p95Ms: 100 },
  summary: 'Audit › one event: the row, its values before and after and the user agent',
})
export type AuditEventData = ScreenData<typeof adminAuditEventScreen>
